import { type ContentItem } from "features/AssetResults/types";
import { mapCompletionStatus } from "../../common/mapperServices/mapCompletionStatus";
import { CompletionStatus } from "../../Flows/types/enums";
import { type HistoryItem } from "../types";
import { EntityType } from "features/common/types";

const STATUS_STARTED = "STARTED";
const STATUS_REGISTERED = "REGISTERED";
const ENTITY_TYPE_SURVEY = "Survey";
const ENTITY_TYPE_ASSESSMENT = "Assessment";

function mapStatusValueToEnum(status: string): number {
  const upperStatus = status.toUpperCase();

  switch (upperStatus) {
    case STATUS_STARTED:
    case STATUS_REGISTERED:
      return CompletionStatus.InProgress;

    default:
      return CompletionStatus.Finished;
  }
}

function mapToEntityType(status: string): EntityType {
  const upperStatus = status.toUpperCase();

  const entityTypeMap: Record<string, EntityType> = {
    FLOW: EntityType.Flow,
    EXTERNALEVENT: EntityType.Event,
    VIDEO: EntityType.Video,
    SURVEY: EntityType.Survey,
    ASSESSMENT: EntityType.Assessment,
    PDF: EntityType.Pdf,
    EMBEDDEDVIDEO: EntityType.EmbeddedVideo,
  };

  return entityTypeMap[upperStatus] || (status as unknown as EntityType);
}

export function mapToHistoryItems(searchResults: HistoryItem[]): ContentItem[] {
  return searchResults.map(mapToHistoryItem);
}

export function mapToHistoryItem(searchResult: HistoryItem): ContentItem {
  const statusEnum = mapStatusValueToEnum(searchResult.Status);
  const entityType = mapToEntityType(searchResult.Type);
  const thumbnailUrl =
    entityType === EntityType.Survey || entityType === EntityType.Assessment ? undefined : searchResult.ThumbnailUrl;
  return {
    id: searchResult.Id,
    duration: searchResult.DurationMinutes,
    thumbnailUrl: thumbnailUrl,
    completionStatus: mapCompletionStatus({ entityType: entityType, completionStatus: statusEnum }),
    title: searchResult.Title,
    description: searchResult.Description,
    entityType: entityType,
    dateAdded: searchResult.ProgressDatetime,
    dateModified: searchResult.ProgressDatetime,
    expired: false,
    dueDate: searchResult.DueDate,
    progressDatetime: searchResult.ProgressDatetime,
    uuid: crypto.randomUUID(), // This is temporarily due to there being no guaranteed unique identifier in the return, as multiple items can have the same ID, as well as all other fields, such as progressDatetime.
  };
}
